import { render, staticRenderFns } from "./PasswordSetup.vue?vue&type=template&id=305a5b13&"
import script from "./PasswordSetup.vue?vue&type=script&lang=js&"
export * from "./PasswordSetup.vue?vue&type=script&lang=js&"
import style0 from "./PasswordSetup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports